<template>
  <span class="position-relative">
    <span class="inside-text">
      <slot />
    </span>
    <div
      class="inside-block"
      :style="`background-color: var(--bs-${color});`"
    />
  </span>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'blue-400',
    },
  },
};
</script>

<style scoped>
.inside-block {
  border-radius: 100px;
  position: absolute;
  width: 100%;
  top: 0.15em;
  height: 0.75em;
  right: 0;
  left: 0;
  z-index: 0;
}
.inside-text {
  position: relative;
  z-index: 1;
}
</style>
